import React from 'react';
import { useProcessInstanceId } from 'domain/gpo/cockpit/instance/processInstanceRoute';
import useProcessInstanceService from 'domain/gpo/cockpit/instance/processInstanceService';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import RedmineIssueField from 'infrastructure/integrations/redmine/RedmineIssueField';
import { FullDateField, TextField } from 'framework/ui/field';
import RedmineUserField from 'infrastructure/integrations/redmine/RedmineUserField';

const SupportIssuesTable = () => {
  const id = useProcessInstanceId();
  const { getSupportIssues } = useProcessInstanceService();

  const getDataMethod = async () => {
    const issues = await getSupportIssues(id);
    return issues;
  };

  return (
    <RelatedList getDataMethod={getDataMethod}>
      <RelationListLayout header="Support Requests" actions={[]}>
        <DataGridLayout showTotal={false} buttons={[]} isSmallTable>
          <RedmineIssueField source="id" />
          <TextField source="subject" />
          <RedmineUserField label="Assignee" nameSource="assignee.name" source="assignee.id" />
          <FullDateField label="Created at" source="createdAt" />
          <FullDateField label="Closed at" source="closedAt" />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedList>
  );
};

export default SupportIssuesTable;
